<template>
  <div>
    <div class="bg-white border shadow shadow-sm">
      <el-tag type="primary">Testing Panel {{$route.params.division}} Division</el-tag>
      <small class="ml-2 text-info">Search By Vendor</small> <el-switch @change="searchMethod"  v-model="searchByVendorOption"></el-switch>
      <span class="float-right mr-3 font-weight-bold pt-1" style="font-size: 10pt">
        Please Allow Our IP: {{$store.state['user-state'].ourVOSIP}}
      </span>
    </div>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>

<script>
export default {
  data () {
    return {
      searchByVendorOption: $store.state['voip-testing-panel-state'].searchByVendorOption
    }
  },
  methods: {
   searchMethod () {
     $store.state['voip-testing-panel-state'].searchByVendorOption = this.searchByVendorOption
   }
  }
}
</script>
